import dayjs, { Dayjs } from 'dayjs';
import {
  LessonsPeriodicity,
  SectionSchedule,
} from '../../../types/sectionMaintainerTypes';

// Mapeo de días de la semana
const DAY_MAP = {
  Lu: 1,
  Ma: 2,
  Mi: 3,
  Ju: 4,
  Vi: 5,
  Sa: 6,
  Do: 0,
};

const PERIODICITY_MAP = {
  Semanal: 1,
  Bisemanal: 2,
  Mensual: 4,
};

/**
 * Genera las fechas específicas de clases basándose en un horario recurrente
 * @param schedule - Horario de sección con rango de fechas y periodicidad
 * @returns Array de fechas (Dayjs) donde se realizan las clases
 */
export function generateLessonDates(schedule: SectionSchedule): Dayjs[] {
  if (!schedule.startDate || !schedule.endDate) {
    return [];
  }

  const dates: Dayjs[] = [];
  const targetDayNum = DAY_MAP[schedule.day as keyof typeof DAY_MAP];
  const start = dayjs(schedule.startDate);
  const end = dayjs(schedule.endDate);

  // Encontrar primer día que coincida con el día de la semana objetivo
  let current = start;
  while (current.day() !== targetDayNum && current.isBefore(end)) {
    current = current.add(1, 'day');
  }

  // Generar fechas según periodicidad
  let weekIncrement =
    PERIODICITY_MAP[schedule?.lessonsPeriodicity ?? LessonsPeriodicity.Weekly];

  while (current.isSameOrBefore(end)) {
    dates.push(current);
    current = current.add(weekIncrement, 'week');
  }

  return dates;
}
